export const getAuthUrl = (string: string) => `/admin${string}`;
export const getCardUrl = (string: string) => `/catalog-items/${string}`;
export const getBasketsUrl = (string: string) => `/admin/basket${string}`;

export const getBasketUrl = (string: string) =>
  `/catalog-items-basket${string}`;

export const getAdminReviews = (string: string) =>
  `/admin/review-comment${string}`;
export const getReviews = (string: string) => `/review-comment${string}`;

export const setCommentUrl = (string: string) => `/admin/comment${string}`;
export const getComment = (string: string) => `/comment${string}`;

export const getLike = (string: string) => `/admin/like${string}`;

export const getUdateOrg = (string: string) =>
  `/admin/users-update-org${string}`;
export const getSuggestionsUrl = () =>
  'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party';
